// @core/api/endpoints/workflow/retry_execution.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineExecutionResponse,
  RetryExecutionRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Retry execution
 * Creates a new execution that replays from a specific node, reusing successful node outputs from the original execution.
 */
export async function RetryExecution(
  execution_id: string,
  data: RetryExecutionRequest,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/executions/:execution_id/retry`;
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.post<PipelineExecutionResponse>(requestPath, data, requestOptions);
}
